import InfoIcon from "@mui/icons-material/Info";
import OpenInFull from "@mui/icons-material/OpenInFull";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { GridColDef } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import NewButton from "../../components/Buttons/NewButton";
import SearchButton from "../../components/Buttons/SearchButton";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import CommonTable from "../../components/CustomTable/CommonTable";
import { Title } from "../../components/Desc";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useGetAllBandobastQuery } from "../../services/appln";
import { getRowsPerPage } from "../constants";
import { convertDate, doesPermissionExist } from "../util";
import DeleteBandobast from "./DeleteBandobast";
import EditBandobast from "./EditBandobast";
import NewBandobast from "./NewBandobast";

export default function ListBandobast() {
  const navigate = useNavigate();

  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(getRowsPerPage());

  const [searchTerm, setSearchTerm] = React.useState("");

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);

  const getParams = {
    page: pageNo,
    limit: rowsPerPage,
    search: searchTerm,
  };

  const bandobastQueryResponse = useGetAllBandobastQuery(getParams);

  const columns: GridColDef[] = [
    {
      field: "serialNo",
      headerName: strings.serialNo,
      width: 150,
    },
    {
      field: "name",
      headerName: strings.name,
      width: 250,
    },
    {
      field: "startDate",
      headerName: strings.startDate,
      width: 200,
      renderCell: (params: any) => {
        return <>{convertDate(params.row.startDate)}</>;
      },
    },
    {
      field: "endDate",
      headerName: strings.endDate,
      width: 200,
      renderCell: (params: any) => {
        return <>{convertDate(params.row.endDate)}</>;
      },
    },
    {
      field: "edit",
      headerName: "",
      width: 10,
      renderCell: (params: any) =>
        doesPermissionExist("update-bandobast") && (
          <EditBandobast id={params.id} initialValues={params} />
        ),
    },
    {
      field: "delete",
      headerName: "",
      width: 10,
      renderCell: (params: any) =>
        doesPermissionExist("delete-bandobast") && (
          <DeleteBandobast id={params.id} />
        ),
    },
    {
      field: "details",
      headerName: "",
      width: 10,
      renderCell: (params: any) => (
        <IconButton
          color="secondary"
          onClick={() => navigate(`/bandobastDetails/${params.id}`)}
        >
          <InfoIcon />
        </IconButton>
      ),
    },
    {
      field: "dashboard",
      headerName: "",
      width: 10,
      renderCell: (params: any) => {
        console.log("params", params);
        const toStore = { id: params.row.id, name: params.row.name };
        localStorage.setItem("bandobast", JSON.stringify(toStore));
        return (
          <IconButton
            color="secondary"
            onClick={() => navigate(`/bandobast/${params.id}`)}
          >
            <OpenInFull />
          </IconButton>
        );
      },
    },
  ];

  const handleChangePage = (event: any, value: any) => {
    setPageNo(value);
  };

  const handleChangeCount = (e: any) => {
    setRowsPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Title text={strings.bandobast}></Title>
          </Grid>
          {(bandobastQueryResponse.isLoading ||
            bandobastQueryResponse.isFetching) && <ProgressIndicator />}
          {doesPermissionExist("create-bandobast") ? (
            <>
              <Grid item xs={2}>
                <div>
                  <NewButton
                    onClickHandler={() => {
                      setNewDialogOpen(true);
                    }}
                  />
                  <NewBandobast
                    onSubmitHandler={(id: any) => {
                      console.log("onSubmitHandler, newObj:", id);
                      setNewDialogOpen(false);
                      navigate(`/bandobast/${id}`);
                    }}
                    onCancelHandler={() => {
                      console.log("onCancelHandler");
                      setNewDialogOpen(false);
                    }}
                    state={newDialogOpen}
                  />
                </div>
              </Grid>
              <Grid item xs={10}>
                <SearchButton
                  onClickHandler={(searchTerm: string) => {
                    setSearchTerm(searchTerm);
                  }}
                />
              </Grid>
            </>
          ) : (
            <Grid item xs={12}>
              <SearchButton
                onClickHandler={(searchTerm: string) => {
                  setSearchTerm(searchTerm);
                }}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={
                  bandobastQueryResponse.data
                    ? bandobastQueryResponse.data?.data
                    : []
                }
                // TODO: commented since edit/delete icons cannot be clicked.
                // onRowClicked={(row: any) => {
                //   console.log("In onRowClicked, row:", row);
                //   navigate(`/bandobastDetails/${row.id}`);
                // }}
                columns={columns}
              />
              <CommonPagination
                count={Math.ceil(
                  bandobastQueryResponse.data?.totalCount / rowsPerPage,
                )}
                page={pageNo}
                handleChangePage={handleChangePage}
                rowPerPage={rowsPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
